import { mdiAccountArrowLeft } from '@mdi/js';
import React from 'react';
import { ProviderActionButton } from './provider-action-button';

interface IProviderUndoneButtonProps {
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}

export const ProviderUndoneButton: React.FunctionComponent<IProviderUndoneButtonProps> = (
    props: IProviderUndoneButtonProps,
): React.ReactElement => {
    return <ProviderActionButton icon={mdiAccountArrowLeft} tooltipPrefix="to Inbox for Provider" {...props} />;
};

